import {
  MAGAZINE_EDIT, MAGAZINE_EDIT_FAILURE, MAGAZINE_EDIT_SUCCESS,
  MAGAZINE_UPDATE, MAGAZINE_UPDATE_FAILURE, MAGAZINE_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    magazine: null
  },
  getters: {
    magazineDetailEdit: state => {
      return state.magazine
    }
  },
  actions: {
    [MAGAZINE_EDIT] ({dispatch, state, commit}, params) {
      var url = '/master/magazines/' + params.id + '/edit'
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MAGAZINE_EDIT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(MAGAZINE_EDIT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MAGAZINE_UPDATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/magazines/' + params.id, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(MAGAZINE_UPDATE_FAILURE, res.data)
            } else {
              commit(MAGAZINE_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [MAGAZINE_EDIT_FAILURE] (state, data) {
      console.log('MAGAZINE_EDIT_FAILURE')
    },
    [MAGAZINE_EDIT_SUCCESS] (state, data) {
      console.log('MAGAZINE_EDIT_SUCCESS')
      state.magazine = data.data
      data.callback()
    },
    [MAGAZINE_UPDATE_FAILURE] (state, data) {
      console.log('MAGAZINE_UPDATE_FAILURE')
    },
    [MAGAZINE_UPDATE_SUCCESS] (state, data) {
      console.log('MAGAZINE_UPDATE_SUCCESS')
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/magazine-edit.js